import Accordion from "@components/Accordion";
import { AccessBadge } from "@components/Accesses/components/AccessBadge";
import { AccessCardInfo } from "@components/Accesses/components/AccessCardInfo";
import AccessScanTicketsButton from "@components/Accesses/components/AccessScanTicketsButton";
import LArtwork from "@components/LArtwork";
import LBox from "@components/LBox";
import LText from "@components/LText";
import { useArtistProfile } from "@hooks/trpc/useArtists";
import { theme } from "@theme";
import dayjs from "dayjs";
import React from "react";
import { getAccessImage } from "@utils/accesses/access";
import { RouterOutputs } from "@utils/trpc";

type ManagedAccessCardProps = {
  access: RouterOutputs["user"]["managedArtists"]["getAccessById"];
};

const ManagedAccessCard = ({ access }: ManagedAccessCardProps) => {
  const coverImageUrl =
    access.type === "event" ? access.coverImageUrl : undefined;
  const artistImage = access.type === "event" ? access.artistImage : undefined;

  const {
    query: { data: artist },
  } = useArtistProfile(access.artistId, {
    enabled: !coverImageUrl && !artistImage,
  });

  const isActive =
    access.type === "event"
      ? dayjs(access.startDateTime).isAfter(dayjs())
      : true;

  return (
    <Accordion
      backgroundColor="favouriteTileBg"
      borderColor="whiteBorder"
      borderRadius="m-l"
      borderWidth={1}
      showDivider={false}
      title="managed_access_card"
    >
      <Accordion.Header padding="s2" showExpandIndicator={true}>
        <LBox
          flexDirection="row"
          alignItems={"center"}
          height={68}
          gap="s2"
          opacity={isActive ? 1 : 0.5}
        >
          <LArtwork
            url={
              getAccessImage(access) ||
              artistImage ||
              artist?.image ||
              artist?.albums.at(0)?.image
            }
            imageStyle={{ height: 68, aspectRatio: 1.06 }}
            borderRadius="m"
          />
          <LBox justifyContent="space-evenly" height={68}>
            <LText variant="bodyLBold">{access.title}</LText>
            {access.type === "event" && <AccessCardInfo access={access} />}
          </LBox>
        </LBox>
        <LBox
          position="absolute"
          right={theme.spacing.s1}
          bottom={theme.spacing.s1}
        >
          <AccessBadge access={access} />
        </LBox>
      </Accordion.Header>
      <Accordion.Content
        gap="s1"
        padding="s2"
        borderTopWidth={1}
        borderColor="whiteBorder"
      >
        {access.type === "event" && (
          <AccessScanTicketsButton
            accessId={access.id}
            accessDate={access.startDateTime}
          />
        )}
      </Accordion.Content>
    </Accordion>
  );
};

export default ManagedAccessCard;
